import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_CHECK_SUBMIT_REQUEST,
  PROJECT_INFORMATION_CHECK_SUBMIT_SUCCESS,
  PROJECT_INFORMATION_CHECK_SUBMIT_FAILURE,
  PROJECT_INFORMATION_CHECK_SUBMIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_CHECK_SUBMIT_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_CHECK_SUBMIT_SUCCESS:
      return state
        .set('checkSubmit', fromJS(action.payload))
        .set('isFetching', false)
        .set('status', 200)
        .set('message', 'Submitted Successfully.')
    case PROJECT_INFORMATION_CHECK_SUBMIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('project', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case PROJECT_INFORMATION_CHECK_SUBMIT_RESET:
      return state
        .delete('checkSubmit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-check-submit-reducer.js